import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// Set dynamic favicon and page title from environment variables
const appName = import.meta.env.VITE_APP_NAME || 'NEXOS';
const faviconUrl = import.meta.env.VITE_APP_FAVICON_URL || '/favicon.ico';

// Update page title
document.title = appName;

// Update favicon
const setFavicon = (url: string) => {
  let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url;
};

setFavicon(faviconUrl);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
